// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1F5GD","large":"styles_large__ojJKt"};